import { classNames } from '../../utils/classNames';

function Card({ children, title, description, action, className }) {
  return (
    <section className={classNames('rounded-card border bg-surface-card shadow-card', className)}>
      {(title || description || action) && (
        <header className="flex items-start justify-between gap-4 border-b px-5 py-4">
          <div>
            {title && <h2 className="font-semibold text-content-primary">{title}</h2>}
            {description && <p className="mt-1 text-sm text-content-muted">{description}</p>}
          </div>
          {action}
        </header>
      )}
      <div className="p-5">{children}</div>
    </section>
  );
}

export default Card;
